import React, { useState } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "../pages/Loader";
import { deleteProject } from "../API";
import DeleteActive from "../assets/images/delete2.png";
import DeleteInactive from "../assets/images/disabledDelete2.png";
import DeleteProjectWarningModal from "./modal/DeleteProjectWarningModal";
import "react-tooltip/dist/react-tooltip.css";

const ProjectTable = ({
  list,
  tableHeadings,
  detailHandler,
  loading,
  getAllProjectData,
  paginationLoading,
  searchQuery,
  searchedProjects,
  searchLoading,
}) => {
  const [selectedProject, setSelectedProject] = useState({});

  const deleteTempProjectPromise = async (project_id) => {
    await deleteProject(project_id).then((res) => {
      if (res?.status === 204) {
        window.location.reload();
      }
    });
  };

  // const filteredList = list?.filter(
  //   (item) =>
  //     item?.description.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
  //     item?.acumatica_project_id?.includes(searchQuery) ||
  //     item?.status?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  // );

  const onClickDelete = (item) => {
    setSelectedProject(item);
  };

  const activeList = searchQuery.length >= 2 ? searchedProjects : list;

  const renderRows = (items = []) =>
    items.map((item, key) => (
      <tr key={key}>
        <td className="record-id">
          <div>{item?.acumatica_project_id || "NA"}</div>
        </td>
        <td>{item?.description}</td>
        <td>
          <span className="status-pill">{item?.status || "NA"}</span>
        </td>
        <td className="details-td table-actions">
          <button
            className="btn btn-info detail-btn"
            onClick={() => detailHandler(item?.id)}
          >
            Details
          </button>
          {item?.type === "webtime" && (
            <>
              {item?.isDeletable ? (
                <img
                  src={DeleteActive}
                  className="active-delete"
                  alt=""
                  onClick={() => onClickDelete(item)}
                  data-bs-toggle="modal"
                  data-bs-target="#deleteWarningModal"
                />
              ) : (
                <>
                  <img
                    src={DeleteInactive}
                    className="active-delete"
                    alt=""
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="There are time entries associated with this project"
                  />
                  <ReactTooltip id="my-tooltip" place="top" effect="solid" />
                </>
              )}
            </>
          )}
        </td>
      </tr>
    ));

  return (
    <>
      {loading && <Loader />}
      <div className="table-responsive crew-table all-crew-table data-table-shell project-table-shell">
        <InfiniteScroll
          dataLength={activeList?.length || 0}
          next={() => getAllProjectData("next")}
          hasMore={true}
          loader={
            paginationLoading && <div className="spinner-border" role="status" />
          }
        >
          <table className="table table-striped tableV2 project-table">
            <thead>
              <tr>
                {tableHeadings?.map((item, key) => (
                  <th scope="col" className="table-heading" key={key}>
                    {item}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {searchQuery.length >= 2 ? (
                <>
                  {searchedProjects?.length > 0 ? (
                    renderRows(searchedProjects)
                  ) : searchLoading && !searchedProjects?.length ? (
                    <tr>
                      <td colSpan={tableHeadings?.length}>Searching...</td>
                    </tr>
                  ) : (
                    <tr>
                      <td colSpan={tableHeadings?.length}>No data found</td>
                    </tr>
                  )}
                </>
              ) : (
                <>
                  {list?.length > 0 ? (
                    renderRows(list)
                  ) : !loading && (
                    <tr>
                      <td colSpan={tableHeadings?.length}>No data found</td>
                    </tr>
                  )}
                </>
              )}
            </tbody>
          </table>
        </InfiniteScroll>
        <DeleteProjectWarningModal
          selectedProject={selectedProject}
          deleteTempProjectPromise={deleteTempProjectPromise}
        />
      </div>
    </>
  );
};

export default ProjectTable;
